import { on, ready, query } from './lib/dom.js'

ready(function () {
  var heute = new Date();
  if(document.getElementById('page-home')){
    if( heute.getMonth() == 11 ){
      window.onresize = function() { schneeflocken.resize(); }
      window.onload = function() { schneeflocken.start(); }
    }
  }
})

var schneeflocken = {
  menge: 250,
  farbe: ['#AAAACC', '#F3F3F3', '#F0FFFF', '#2774c7', '#39454C'],
  font: ['Oxygen', 'Arial Narrow', 'Times Bold', 'Comic Sans MS'],
  flocke: '❄',
  geschw: .3,
  min: 8,
  max: 22,
  hdrift: 15,
  zind: 20000,
  flocken: [],
  width: 0,
  height: 0,
  bereich: null,
  anz: 0,
  pause: 10,
  li: 0,
  EvHaResize: window.onresize,
  EvHaLoad: window.onload,

  start: function(){
    if (this.EvHaLoad != null) this.EvHaLoad();
    this.bereich = this.max - this.min;
    this.size();
    while (this.menge > this.flocken.length){
      this.create(this.flocken.length);
    }
    this.li = this.datetime();
    window.setInterval(function() { schneeflocken.move(); }, this.pause);
  },
  datetime: function(){
    return +new Date();
  },
  rdm: function(range){
    return Math.floor(Math.random() * range);
  },
  create: function(i) {
    // select body tag
    var insertBody = document.getElementsByTagName('body')[0];

    // create span child for flake
    var f = document.createElement('div');
    f.id                 = 'flake' + i;
    f.style.position     = 'absolute';
    f.style.left         = '0px';
    f.style.top          = '-' + this.max + 'px';
    f.style.color        = this.farbe[this.rdm(this.farbe.length - 1)];
    f.style.family       = this.font[this.rdm(this.font.length - 1)];
    f.style.fontSize     = (this.rdm(this.bereich) + this.min) + 'px';
    f.style.zIndex       = this.zind;
    f.innerHTML          = this.flocke;
    insertBody.appendChild(f);
    
    // create array element
    this.flocken[i] = {
      x: this.rdm(this.width - this.hdrift - this.max - 3) + this.hdrift + 1,
      y: -this.max - this.rdm(this.height),
      size: this.rdm(this.bereich) + this.min,
      count: this.rdm(10000)
    };
  },
  restart: function(i){
    this.flocken[i] = {
      x: this.rdm(this.width - this.hdrift - this.max - 3) + this.hdrift + 1,
      y: -this.max,
      size: this.rdm(this.bereich) + this.min,
      count: this.rdm(10000)
    };
  },
  move: function(){
    // calculate movement factor
    var dif = this.datetime() - this.li;
    this.li = this.datetime();
    var f = dif * this.geschw;

    this.anz += f / 80;

    for (var i = 0; i < this.flocken.length; i++){
      var flake = this.flocken[i];
      flake.y += f * this.geschw * this.max / flake.size;

      // restart existing flake
      if (flake.y + flake.size >= this.height){
        this.restart(i);
        continue;
      }
      var flakeDiv = document.getElementById('flake' + i);
      flakeDiv.style.left = Math.floor(flake.x + Math.sin(flake.count + this.anz) * this.hdrift) + 'px';
      flakeDiv.style.top  = Math.floor(flake.y) + 'px';
    }
  },
  size: function(){
    var oldWidth = this.width;
    
    this.width = this.winw() - this.max;
    this.height = this.winh() - this.max;
    
    var ratio = this.width / oldWidth;
    
    for (var i = 0; i < this.flocken.length; i++){
      var flake = this.flocken[i];
      flake.x *= ratio;
      
      if ((flake.y + flake.size) >= this.height){
        this.restart(i);
      }
    }
  },
  winw: function(){
    var w = Math.max(self.innerWidth || 0, window.innerWidth || 0);
    
    if (document.documentElement){
      w = Math.max(w, document.documentElement.clientWidth || 0);
    }
    if (document.body) {
      w = Math.max(w, document.body.clientWidth || 0);
      w = Math.max(w, document.body.scrollWidth || 0);
      w = Math.max(w, document.body.offsetWidth || 0);
    }
    return w;
  },
  winh: function(){
    var h = Math.max(self.innerHeight || 0, window.innerHeight || 0);
    
    if (document.documentElement){
      h = Math.max(h, document.documentElement.clientHeight || 0);
    }
    if (document.body) {
      h = Math.max(h, document.body.clientHeight || 0);
      h = Math.max(h, document.body.scrollHeight || 0);
      h = Math.max(h, document.body.offsetHeight || 0);
    }
    return h;
  },
  resize: function()
  {
    if (this.EvHaResize != null){
      this.EvHaResize();
    }
    this.size();
  }
};
